import { ChartDataSet } from "../../types/chart-data-set";
import { PieChartData } from "../../types/pie-chart-data";
import { IChart } from "../interfaces/i-chart";

export class PieChart implements IChart {

    constructor() { }

    getChartOptions(data: ChartDataSet[] = [], displayLegend: boolean = false) {
        let options = {
            responsive: true,
            plugins: {
                legend: {
                    display: displayLegend,
                    position: 'bottom',
                },
                title: {
                    display: true,
                    text: data[0].label ?? 'Sem título'
                }
            }
        }
        return options;
    }

    colors!: string[];

    setColors(colors: string[]): void {
        this.colors = colors;
    }

    /**
     * Gera um gráfico de barras
     * @param data dados do gráfico (Ex.: [{ key: 'Sales', value: 20 }, { key: 'Revenue', value: 10 }])
     * @returns PieChartData
     */
    public getChartData(data: ChartDataSet[]): PieChartData {

        const datasets: any = this.buildDataSet(data);
        const pieChartData: PieChartData = datasets;

        return pieChartData;
    }

    private buildDataSet(data: ChartDataSet[]): any {
        var keys = data.map((d) => d.key);
        var values = data.map((d) => d.value);
        var dataset =
        {
            labels: keys,
            datasets: [{
                data: values,
                backgroundColor: this.colors,
            }],
        }

        return dataset;
    }

}